module.exports = {
      id: "gift-chargeback-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#gift-chargeback-icon",
      toString: function () {
        return this.url;
      }
    }